var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduccionFormacionMaterial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 41,
    viewBox: "0 0 47 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Reduccion-formacion-material"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reduccion-formacion-material",
    clipPath: "url(#clip-Reduccion-formacion-material)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1058",
    "data-name": "Grupo 1058",
    transform: "translate(22882 2566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_filter_drama_24px",
    d: "M29.5,13.208A11.412,11.412,0,0,0,8.172,10.159a9.143,9.143,0,0,0,.976,18.234H28.966A7.6,7.6,0,0,0,29.5,13.208Zm-.534,12.135H9.147a6.1,6.1,0,1,1,6.1-6.1h3.049a9.137,9.137,0,0,0-6.708-8.812,8.37,8.37,0,0,1,15.093,5V16.2h2.287a4.574,4.574,0,0,1,0,9.147Z",
    transform: "translate(-22880.313 -2565.109)",
    fill: "#225B2A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1047",
    "data-name": "Grupo 1047",
    transform: "translate(-22857 -2553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_788",
    "data-name": "Grupo 788",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_171",
    "data-name": "Elipse 171",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#43A7B6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_trending_up_24px",
    d: "M44.765,15.835l2.252-2.252-4.8-4.8-3.934,3.934L33.973,8.376,35.359,6.99l2.924,2.944L42.217,6l6.2,6.186,2.252-2.252v5.9Z",
    transform: "translate(-32.286 -0.325)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduccionFormacionMaterial);
export default __webpack_public_path__ + "static/media/reduccion-formacion-material.7bb3ef992491df9ddcbe76e8bc30110b.svg";
export { ForwardRef as ReactComponent };